import React,{useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import BaseBox from '../../layout/base-box'
import { FormattedMessage } from 'react-intl'
import Checkbox from '../../../../components/checkbox'
import Ask from '../../../../components/ask'
import { unitPrice } from '../../../../../../../utils/product'
import toast from '../../../../../../components/toast'
import { SensorsTrack } from '../../../../../../utils/sensor'
import { QuickShippingTxt } from '../../../../../details/components/product-main-container/quick-shipping'
import {Iconfont} from "../../../../../../components/icon/iconfont";


const ShippingMethod = props => {
    useStyles(classes)
    const { shippingMethod, onShippingMethod, isOversea } = props
    const { title, description2, shippingTime, price, warnMsg, disabledWarnMsg, disabled, freeOverMsg, standardMsg, originalPrice } = shippingMethod

    const clickHandle = e => {

        SensorsTrack('PlaceOrderAction', { action: 'ClickShippingMethod' })


        if (!disabled) {
            onShippingMethod(shippingMethod)
        } else {
            toast(disabledWarnMsg)
        }
    }

    const isFreeShipping = Number(price?.amount) === 0

    return <div className={`${classes.ShippingMethod} ${disabled ? classes.Disabled : ''}`} >
        <div className={classes.CheckBox}>
            <Checkbox disabled={disabled} selected={shippingMethod.selected} onClick={clickHandle} />
        </div>
        <div className={classes.Content}>
            <div className={classes.Title}>
                {
                    description2 ? <React.Fragment>
                        <span className={classes.QuickShippingTipLogo}>
                            <FormattedMessage id="quick_ship" defaultMessage="QuickShip"/>
                        </span>
                        <span style={{ textTransform: 'none' }} dangerouslySetInnerHTML={{ __html: description2 }}></span>
                    </React.Fragment> :
                        title
                }
                {(freeOverMsg && !standardMsg) ? <span className={classes.Condition}>({freeOverMsg})</span> : ''}
                {
                    standardMsg && <span className={classes.FreeShipping}>
                        {standardMsg}
                    </span>
                }
                {warnMsg && <Ask content={warnMsg} />}
            </div>
            <div className={classes.Description}>
                <span className={classes.Price}>{unitPrice(price)}</span>
                {
                    originalPrice && <del className={classes.Del}>
                        {unitPrice(originalPrice)}
                    </del>
                }
                {shippingTime && <span style={{ marginLeft: 10 }} dangerouslySetInnerHTML={{ __html: shippingTime }}></span>}
            </div>
        </div>
    </div>
}

const ShippingMethods = props => {
    useStyles(classes)
    const { shippingMethods, onShippingMethod, isOversea,expandedFlag,expanded } = props
    if(expandedFlag){
        if(expanded){
            return expandedDiv()
        }else{
            return foldDiv()
        }
    }else{
        return expandedDiv()
    }
    function expandedDiv() {
       return <div className={classes.ShippingMethods}>
            {
                shippingMethods?.map(shippingMethod =>
                    <ShippingMethod
                        isOversea={isOversea}
                        onShippingMethod={onShippingMethod}
                        key={shippingMethod?.id}
                        shippingMethod={shippingMethod}
                    />
                )
            }
        </div>
    }
    function foldDiv(){
        const filteredMethods = shippingMethods?.filter(shippingMethod => shippingMethod?.selected === true);
        // 如果没有匹配的 shippingMethod，不渲染任何内容
        if (!filteredMethods || filteredMethods.length === 0) {
            return null;
        }
        return <div className={classes.ShippingMethods}>
            {
                filteredMethods?.map(shippingMethod =>
                    <ShippingMethod
                        isOversea={isOversea}
                        onShippingMethod={onShippingMethod}
                        key={shippingMethod?.id}
                        shippingMethod={shippingMethod}
                    />
                )
            }
        </div>
    }
}

const ShippingInsurance = props => {
    useStyles(classes)
    const { useShippingInsurance, shippingInsuranceMsg, expectedShippingInsurance, onInsurance } = props
    return <div className={classes.ShippingInsurance}>
        <div className={classes.CheckBox}>
            <Checkbox selected={useShippingInsurance} onClick={e => onInsurance(!useShippingInsurance)} />
        </div>
        <div className={classes.Content}>
            <span className={classes.Title}>
                <FormattedMessage id="add_shipping_insurance" defaultMessage="Add Shipping Insurance" /> ({unitPrice(expectedShippingInsurance)})
            </span>
            <Ask content={shippingInsuranceMsg} />
        </div>
    </div>
}


export default props => {
    useStyles(classes)
    // 纯文本箭头示例
    const ArrowDown = () => <Iconfont className={classes.Sword}>&#xe7c7;</Iconfont>;
    const ArrowUp = () => <Iconfont className={classes.Sword}>&#xe63b;</Iconfont>;
    const { shippingInsuranceMsg, shippingMethods, useShippingInsurance, expectedShippingInsurance, onShippingMethod, onInsurance, isOversea, preOrderShippingMethods, preOrderItemCount, itemCount } = props


    // const _preOrderShippingMethods = [
    //     {
    //         "id": "1",
    //         "title": "Standard Shipping",
    //         "price": {
    //             "amount": "0",
    //             "unit": "S$",
    //             "currency": "SGD"
    //         },
    //         "description": "",
    //         "warnMsg": "",
    //         "standardMsg": "Free Shipping",
    //         "shippingTime": "Arrives by <span color='#E64545' style='color:#E64545'>29 Feb - 07 Mar</span>",
    //         "selected": true,
    //         "disabled": false
    //     }
    // ]
    // 控制展开/折叠
    const [expanded, setExpanded] = useState(false);
    // 点击箭头时切换展开状态
    const handleToggle = () => {
        setExpanded(!expanded);
    };
    return <BaseBox ask={shippingMethods?.[0]?.disabledWarnMsg} title={(
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                width: '100%',
            }}onClick={handleToggle}>
            <FormattedMessage id="shipping_method" defaultMessage="Shipping Method" />
            {expanded ? <ArrowUp /> : <ArrowDown />}
        </div>
    )}>
        {/* {
            !isOversea &&
            <QuickShippingTxt isCart={true} htmlValue={shippingMethods}/>
        } */}

        <div className={classes.ShippingBody}>

            {
                preOrderItemCount > 0 ? <React.Fragment>

                    {
                        itemCount > 0 && <div className={classes.ShipBox}>
                            <div className={classes.Hd}>
                                In stock Item(<span className={classes.count}>{itemCount}</span>)
                            </div>
                            <div className={classes.Bd}>
                                <ShippingMethods
                                    shippingMethods={shippingMethods}
                                    onShippingMethod={onShippingMethod}
                                    isOversea={isOversea}
                                    expandedFlag={true}
                                    expanded={expanded}
                                />
                                {
                                    expectedShippingInsurance && <ShippingInsurance expectedShippingInsurance={expectedShippingInsurance} useShippingInsurance={useShippingInsurance} shippingInsuranceMsg={shippingInsuranceMsg} onInsurance={onInsurance} />
                                }
                            </div>
                        </div>
                    }

                    <div className={classes.ShipBox}>
                        <div className={classes.Hd}>
                            Pre Order Item(<span className={classes.count}>{preOrderItemCount}</span>)
                        </div>
                        <div className={classes.Bd}>
                            <ShippingMethods
                                shippingMethods={preOrderShippingMethods}
                                onShippingMethod={() => { }}
                            />
                        </div>
                    </div>
                </React.Fragment> : <React.Fragment>
                    <ShippingMethods
                        shippingMethods={shippingMethods}
                        onShippingMethod={onShippingMethod}
                        isOversea={isOversea}
                        expandedFlag={true}
                        expanded={expanded}
                    />
                    {
                        expectedShippingInsurance && <ShippingInsurance expectedShippingInsurance={expectedShippingInsurance} useShippingInsurance={useShippingInsurance} shippingInsuranceMsg={shippingInsuranceMsg} onInsurance={onInsurance} />
                    }
                </React.Fragment>
            }


        </div>
    </BaseBox>
}